import React from 'react';
import figma from "../assets/figma.png";
import xd from "../assets/xd.png";
import canva from "../assets/canva.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import reactImage from "../assets/reactImage.png";
import photoshop from "../assets/ps.png";
import wordpress from "../assets/wordpress.jpg";

const Experience = () => {
    const technologies =[
        {
            id:1,
            src:figma,
            title:'Figma',
            style:'shadow-red-500'
        },
        {
            id:2,
            src:xd,
            title:'Adobe XD',
            style:'shadow-purple-500'
        },
          {
            id:3,
            src:wordpress,
            title:'WordPress',
            style:'shadow-gray-400',
        },
        
         {
            id:4,
            src:photoshop,
            title:'Phototshop',
            style:'shadow-cyan-200',
        },
      {
            id:5,
            src:canva,
            title:'Canva',
            style:'shadow-blue-500'
        },
        {
            id:6,
            src:reactImage,
            title:'React',
            style:'shadow-cyan-600'
        },
        {
            id:7,
            src:tailwind,
            title:'Tailwind',
            style:'shadow-sky-400'
        },
        {
            id:8,
            src:github,
            title:'GitHub',
            style:'shadow-gray-400',
        },
    ]
  return (
    <div name='experience' className="w-full min-h-screen  py-12 sm:pt-16 md:pt-20 lg:pt-24 bg-gradient-to-r from-sky-950 via-slate-800 to-slate-900">
    <div className="max-w-screen-lg px-9 mx-auto flex flex-col justify-center w-full h-full">
    <div>
        <p className='text-4xl text-white font-bold inline border-b-4 border-gray-200'>Experience</p>
        <p className='py-6 text-white'>Here are the technologies I'm experienced with.</p>
    </div>
    <div className="w-full grid  grid-cols-2 text-white sm:grid-cols-3 gap-8 text-center py-8 sm:px-0">
        {technologies.map(({id, src, title, style}) => (
        <div key={id}
            className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}>
        <img src={src} alt="" className='w-20 mx-auto'/>
        <p className='mt-4'>{title}</p>
        </div>
         )) }

    </div>
</div>
    </div>
  )
}

export default Experience
